import { Expression } from '../builder';
import { ParseRes, ParseCtx } from './eraql-ast/ast';
import { parseExpr } from './parse';
import { Ty } from '../ty';
import _ from 'lodash';
import { exprToEraQL } from './to-eraql/expr-to-eraql';

type RawEraqlExpressionCompiler = (
  rawCode: readonly string[],
  keys: readonly (Ty.Scalar | Expression)[],
  ctx: ParseCtx
) => ParseRes<Expression>;

export type EraqlExpressionCompiler = (
  rawCode: readonly string[],
  ...keys: readonly (Ty.Scalar | Expression)[]
) => Expression;

const rawQlExpressionCompiler: RawEraqlExpressionCompiler = (
  rawCode,
  keys,
  opts
) => {
  const parts: string[] = [];

  for (const [code = '', interpolated] of _.zip(rawCode, keys)) {
    parts.push(code);

    if (interpolated !== undefined) {
      const expr = Expression.wrap(interpolated);
      // parens are required to not break operator precedence
      parts.push(`(${exprToEraQL(expr.ir(), { refs: {} })})`);
    }
  }

  const eraCode = parts.join('');
  return parseExpr(eraCode, opts);
};

export const makeEraqlExpressionCompiler = (
  ctx: ParseCtx,
  opts: {
    jsStackPointer?: Function;
  }
): EraqlExpressionCompiler => {
  const inner: EraqlExpressionCompiler = (rawCode, ...keys) => {
    const { jsStackPointer = inner } = opts;
    const res = rawQlExpressionCompiler(rawCode, keys, ctx);

    if (res.isErr()) {
      const [e, _meta] = res.error;
      if (e && e[0].t === 'type-check-error') {
        throw e[0].trace.toError({ jsStackPointer });
      } else {
        const error = new Error(`${e![0].t}`);

        if ((Error as any).captureStackTrace && jsStackPointer !== undefined) {
          (Error as any).captureStackTrace(error, jsStackPointer);
        }

        throw error;
      }
    }

    return res.value;
  };

  return inner;
};
